import React, { useState } from "react";
import "../../../App.css";
import { RxCross2 } from "react-icons/rx";
import { MdOutlineSaveAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { creatTypeFieldAction } from "../../Actions/TypeFieldAction/TypeFieldAction";
const TypeFieldModal = ({ closeModal, id }) => {
  const dispatch = useDispatch();
  const createTypeField = useSelector((state) => state.createTypeField);
  const { error } = createTypeField;
  const [state, setState] = useState({
    name: "",
    label: "",
    placeholder: "",
    type: "",
  });
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(
      creatTypeFieldAction(
        id,
        state.name,
        state.label,
        state.placeholder,
        state.type,
        closeModal
      )
    );
  };
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container">
          <div className="modal-header ">
            <h3 className="cursor-pointer text-red-500" onClick={closeModal}>
              <RxCross2 />
            </h3>
          </div>
          <form action="">
            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  value={state.name}
                  name="name"
                  onChange={handleStateChange}
                  className="input"
                  placeholder="Name"
                />
                <p className="text-red-500"> {error && error.name}</p>
              </div>

              <div className="flex flex-col">
                <label htmlFor="label">Label</label>
                <input
                  type="text"
                  id="label"
                  value={state.label}
                  name="label"
                  onChange={handleStateChange}
                  className="input"
                  placeholder="Label"
                />
                <p className="text-red-500"> {error && error.label}</p>
              </div>
              <div className="flex flex-col">
                <label htmlFor="placeholder">placeholder</label>
                <input
                  type="text"
                  value={state.placeholder}
                  name="placeholder"
                  onChange={handleStateChange}
                  id="placeholder"
                  className="input"
                  placeholder="placeholder"
                />
                <p className="text-red-500"> {error && error.placeholder}</p>
              </div>

              <div className="flex flex-col">
                <label htmlFor="type">Type</label>
                <select
                  value={state.type}
                  onChange={handleStateChange}
                  name="type"
                  className="input"
                  id="type"
                >
                  <option value="">Select Type</option>
                  {["dropdown"].map((drop, index) => {
                    return (
                      <option key={index} value={drop}>
                        {drop}
                      </option>
                    );
                  })}
                </select>
                <p className="text-red-500"> {error && error.name}</p>
              </div>
            </div>
            <button
              onClick={handleSubmit}
              className="btn-info mt-2 flex gap-2 items-center"
            >
              Save <MdOutlineSaveAlt />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TypeFieldModal;
